<script>
import api from '@/helpers/api'
import { required, email, helpers } from 'vuelidate/lib/validators'
import stepHelper from './step-helper'
export default {
  name: 'form.form.general',
  props: {
    value: { type: Object, default: () => {} }
  },
  mixins: [stepHelper],
  data: vm => ({
    form: {
      ...vm.value
    }
  }),
  methods: {
    validate () {
      return this.__validateForm()
    }
  },
  validations () {
    return {
      form: {
        legal_name: {
          required
        },
        number: {
          required,
          async unique (v) {
            return (
              !helpers.req(v) ||
              (await api.suppliers.numberIsUnique({ value: v }))
            )
          }
        },
        vat_number: {
          async unique (v) {
            return (
              !helpers.req(v) ||
              (await api.suppliers.vatNumberIsUnique({ value: v }))
            )
          }
        },
        primary_email: {
          email
        }
      }
    }
  }
}
</script>
<template>
  <div>
    <b-form-group label="Supplier N°" label-for="number" label-cols-sm="3">
      <b-form-input
        id="number"
        v-model="form.number"
        :class="{ 'is-invalid': $v.form.number.$error }"
        aria-describedby="err_number"
        readonly
        :style="{ width: '150px' }"
      ></b-form-input>
      <b-form-invalid-feedback id="err_number">
        <template v-if="!$v.form.number.required">Field is required</template>
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Legal Name" label-for="legal_name" label-cols-sm="3">
      <b-form-input
        id="legal_name"
        v-model="form.legal_name"
        autocomplete="legal_name"
        placeholder="Legal name of the company"
        :style="{ width: '350px' }"
        :class="{ 'is-invalid': $v.form.legal_name.$error }"
        aria-describedby="err_legal_name"
      ></b-form-input>
      <b-form-invalid-feedback id="err_legal_name">
        <template v-if="!$v.form.legal_name.required">
          Legal Name is required
        </template>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="VAT N°" label-for="vat_number" label-cols-sm="3">
      <b-form-input
        id="vat_number"
        v-model="form.vat_number"
        autocomplete="vat_number"
        placeholder="Ex. BE27897439743"
        :style="{ width: '350px' }"
        :class="{ 'is-invalid': $v.form.vat_number.$error }"
        aria-describedby="err_vat_number"
      ></b-form-input>
      <b-form-invalid-feedback id="err_vat_number">
        <template v-if="!$v.form.vat_number.unique"
          >VAT Number is already used!</template
        >
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Email" label-for="primary_email" label-cols-sm="3">
      <b-form-input
        id="primary_email"
        v-model="form.primary_email"
        type="email"
        autocomplete="new--password"
        placeholder="Primary Email address"
        :style="{ width: '350px' }"
        :class="{ 'is-invalid': $v.form.primary_email.$error }"
        aria-describedby="err_primary_email"
      ></b-form-input>
      <b-form-invalid-feedback id="err_primary_email">
        <template v-if="!$v.form.primary_email.email">
          Must be an Email address
        </template>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Phone" label-for="primary_phone" label-cols-sm="3">
      <b-form-input
        id="primary_phone"
        v-model="form.primary_phone"
        autocomplete="primary_phone"
        placeholder="ex. +32 4565663"
        :style="{ width: '350px' }"
      ></b-form-input>
    </b-form-group>
  </div>
</template>
